import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import type { RequestData } from 'src/types/requestData';

export type ImportProjectJobsResultPayload = {
  errors?: Record<string, string[]>;
  warnings?: Record<string, string[]>;
  result_file_path?: string | null;
};

type ImportProjectJobsResultAttributes = {
  admin_id: number;
  project_id: number;
  status: 'success' | 'failure';
  result?: ImportProjectJobsResultPayload;
};

type ImportProjectJobsResultResponse =
  | RequestData<ImportProjectJobsResultAttributes>
  | { data: null };

export const getImportProjectJobsResult = async (projectUuid: string) => {
  const { data: responseBody } =
    await getRequest<ImportProjectJobsResultResponse>(
      API.GET.getImportProjectJobsResult(projectUuid),
    );

  if (responseBody.data === null) {
    return null;
  }

  return responseBody.data.attributes;
};
